export default "__VITE_ASSET__DT3IG$QK__"